import { render, staticRenderFns } from "./stay.vue?vue&type=template&id=2d9be5af&scoped=true&"
import script from "./stay.vue?vue&type=script&lang=js&"
export * from "./stay.vue?vue&type=script&lang=js&"
import style0 from "./stay.vue?vue&type=style&index=0&id=2d9be5af&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9be5af",
  null
  
)

export default component.exports